import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import { getImage } from 'gatsby-plugin-image'
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Text } from "../../../Text/Text"


interface OwnProps {
  author: string;
  body: string;
}

export type ReviewItemProps = OwnProps

export const ReviewItem: React.FC<ReviewItemProps> = ({
  author,
  body
}) => {
    const imageQuery = useStaticQuery(graphql`
    query ReviewStars {
      star: file(
        relativePath: { eq: "reviews/star.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, width: 24)
        }
        publicURL
      }
    }
  `)

  const starImage = getImage(imageQuery.star)

  const { t } = useTranslation("shared", {
    keyPrefix: "location_pages.reviews",
  });

  return (
    <div className="bg-light-wool p-5">
      <div>
        <Text variant="small-subheader">{author}</Text>
      </div>
      <div className="mt-5 [&>*]:inline-block">
        {[...Array(5)].map((x, i) =>
          <GatsbyImage
            alt={t("star_image_alt")}
            image={starImage}
            key={i}
          />
        )}
        <div className="sr-only">{t("5_star_rating")}</div>
      </div>
      <div className="mt-5">
        <Text variant="body">{body}</Text>
      </div>
    </div>
  )
}
